import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Dedicated axios instance for the Brightridge Partners intern portal.
// Uses a separate localStorage token so both portals can co-exist in one browser.
const partnersApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

partnersApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('partners_portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

partnersApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/partners/accept-invite')) {
      localStorage.removeItem('partners_portal_token');
      localStorage.removeItem('partners_portal_employee');
      if (!window.location.pathname.startsWith('/partners/login')) {
        window.location.href = '/partners/login';
      }
    }
    return Promise.reject(err);
  }
);

// Auth endpoints are shared with the EOR portal (same JWT flavour, same DB).
export const partnersAuthAPI = {
  checkInvite: (token) => partnersApi.get(`/eor-portal/invite/${token}`),
  acceptInvite: (token, password) => partnersApi.post('/eor-portal/accept-invite', { token, password }),
  login: (email, password) => partnersApi.post('/eor-portal/login', { email, password }),
  me: () => partnersApi.get('/eor-portal/me'),
  updateProfile: (data) => partnersApi.patch('/eor-portal/me', data),
};

export const partnersPortalAPI = {
  policies: () => partnersApi.get('/partners-portal/policies'),
  acknowledge: (id, typedName) => partnersApi.post(`/eor-portal/policies/${id}/acknowledge`, { typed_name: typedName, consent: true }),
  contract: () => partnersApi.get('/partners-portal/contract'),
  contractDownloadUrl: () => `${API_BASE}/partners-portal/contract/download`,
  summary: () => partnersApi.get('/partners-portal/summary'),
  finalize: (typedName) => partnersApi.post('/partners-portal/contract/finalize', { typed_name: typedName }),
  signedOfferDownloadUrl: () => `${API_BASE}/partners-portal/signed-offer/download`,

  // Onboarding documents (aadhaar, pan, bank_proof, photo) — shared eor-portal upload endpoint.
  listDocuments: () => partnersApi.get('/eor-portal/documents'),
  uploadDocument: (docType, file) => {
    const fd = new FormData();
    fd.append('doc_type', docType);
    fd.append('label', docType);
    fd.append('file', file);
    return partnersApi.post('/eor-portal/documents', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // Bank details (Indian intern payroll target)
  getBankDetails: () => partnersApi.get('/partners-portal/bank-details'),
  saveBankDetails: (payload) => partnersApi.put('/partners-portal/bank-details', payload),
};

export default partnersApi;
